export const paths = {
	home: "/",
	auth: {
		custom: {
			signIn: "/auth/custom/sign-in",
		},
	},
	dashboard: {
		overview: "/dashboard",
		wealthInsider: {
			overview: "/dashboard/wealth-insider",
			reports: "/dashboard/wealth-insider/reports",
			report: (reportId) => `/dashboard/wealth-insider/reports/${reportId}`,
			algorithms: "/dashboard/wealth-insider/algorithms",
			universes: "/dashboard/wealth-insider/universes",
			schedules: "/dashboard/wealth-insider/schedules",
			activity: "/dashboard/wealth-insider/activity",
		},
	},
	notAuthorized: "/errors/not-authorized",
	notFound: "/errors/not-found",
	internalServerError: "/errors/internal-server-error",
};
